import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from '../ng-login/auth/auth.service';
import { Customer } from '../../models/customer';
import { MenuItemInterface } from '../../interfaces/menu.interface';
import { Router } from '@angular/router';
import { getStorageObject } from '../../utils/storage-manager';

/**
 * Component selector, template-form, style and animations
 */
@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})

/**
 * Navigation bar component
 */
export class NavigationComponent {
  /**
   * Menu items
   */
  @Input() public menuItems: MenuItemInterface[] = [];

  /**
   * Menu items to be positioned at the bottom of the navigation bar
   */
  @Input() public bottomMenuItems: MenuItemInterface[] = [];

  /**
   * Emits when the window size is changed
   */
  @Output() public sizeChangedEvent: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Display mode. Can be either 'full' or 'compact'
   */
  public mode: 'compact' | 'full' = 'full';

  /**
   * Menu items display direction. Can be either 'row' or 'column'
   */
  public menuItemsDirection: 'row' | 'column' = 'column';

  /**
   * Flex align for items inside the menu
   */
  public flexAlign: 'start center' | 'center center' = 'center center';

  protected currentCustomer: Customer = getStorageObject('vertical');

  /**
   * Constructor
   * @param {AuthService} authService Auth service
   * @param {Router} router Angular router
   */
  constructor(
    public authService: AuthService,
    private router: Router
  ) {}
  /**
   * Logout callback
   */
  logout(): void {
    this.authService.logout();
    this.router.navigateByUrl('vertical-selector');
  }

  /**
   * Toggle display sidebar display mode
   * @param event
   */
  toggleMode(event: Event): void {
    event.preventDefault();
    const newMode = this.mode;
    this.mode = newMode === 'full' ? 'compact' : 'full';
    this.menuItemsDirection = this.mode === 'full' ? 'row' : 'column';
    this.flexAlign = this.menuItemsDirection === 'row' ? 'start center' : 'center center';
    this.sizeChangedEvent.emit(true);
  }
}
